import { render } from "./OrderPreviewModal.vue?vue&type=template&id=332da2a2"
import script from "./OrderPreviewModal.vue?vue&type=script&lang=js"
export * from "./OrderPreviewModal.vue?vue&type=script&lang=js"

import "./OrderPreviewModal.vue?vue&type=style&index=0&id=332da2a2&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__